import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute = ({ children, roles, permission, deptGate }) => {
  const { user, loading, homeRoute, hasPermission } = useAuth();

  if (loading) return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
    </Box>
  );

  if (!user) return <Navigate to="/login" replace />;

  // Department-based gate (e.g. HR on-behalf returns) takes precedence when set.
  if (deptGate) {
    if (!deptGate(user)) return <Navigate to={homeRoute} replace />;
    return children;
  }

  // Permission-based gate: access if the user holds the permission (admin
  // implicitly passes). When both `roles` and `permission` are supplied, a
  // match on EITHER grants access, so legacy role lists stay backward-compatible
  // while the feature also becomes assignable to any role via Role Management.
  if (permission) {
    const byRole = roles ? roles.includes(user.role) : false;
    const byPermission = typeof hasPermission === 'function' && hasPermission(permission);
    if (!byRole && !byPermission) return <Navigate to={homeRoute} replace />;
    return children;
  }

  // Role not permitted → send them to their own home, not a dead-end
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeRoute} replace />;
  }

  return children;
};
